import { render } from "./RequestButton.vue?vue&type=template&id=69cd39d6"
import script from "./RequestButton.vue?vue&type=script&lang=js"
export * from "./RequestButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__